/**
 * Holistic pipeline percent band constants (shared by uploadProgress and frame helpers).
 */

/** Unified SfM (hloc + COLMAP) occupies the holistic bar from 5% → 50%. */
export const SFM_PERCENT_START = 5;
export const SFM_PERCENT_END = 50;
/** Gaussian training band (51–92) before finalizing (export + SOG). */
export const GAUSSIAN_PERCENT_START = 51;
export const GAUSSIAN_PERCENT_END = 92;
export const FINALIZING_PERCENT_START = 92;
export const FINALIZING_PERCENT_END = 100;
